import { TransacoesDTO } from './cadastro/saude/TransacoesDTO';
import { PageResultDTO, ServerSidePaging } from '@/api/commons/PageResult';
import { FiltroComprovanteTransferenciaDTO, AtendimentoNotaFiscalDTO, ConfirmarComprovanteTransferenciaDTO } from './cadastro/saude/ComprovanteTransferenciaDTO';
import { JustificativaValorAdicionalDTO } from './cadastro/JustificativaValorAdicionalDTO';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { JustificativaRecusaDTO } from './cadastro/saude/JustificativaRecusaDTO';
import { ObservacaoAprovacaoDTO } from './cadastro/saude/ObservacaoAprovacaoDTO';
import { OrcamentoDTO } from './cadastro/saude/OrcamentoDTO';
import { RetornoMensagemDTO } from './cadastro/saude/RetornoMensagemDTO';
import { servicosSaudeApiConfig } from "./config";
import { EspecialidadeFiltroDTO } from './cadastro/saude/EspecialidadeFiltroDTO';
import { EspecialidadeDTO } from './cadastro/saude/EspecialidadeDTO';

class ServicosSaudeAtendimentoApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  pesquisarAtendimentos(filtro: any, serialize?: boolean): Promise<any> {
    return this.get(`/atendimento/central`, {
      params: filtro,
      paramsSerializer: function(params) {
        console.log(params);
        return Object.entries(params)
          .map(([key, value]) => !!value ? `${key}=${value}` : '').
          join('&');
      }
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  obterAtendimentoPorId(id: Number): Promise<any> {
    return this.get(`/atendimento/central/${id}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter atendimento.");
      });
  }

  obterZipRequerimentoMedico(idAtendimento: number, fileName: string): Promise<any> {
    return this.get(`/atendimento/${idAtendimento}/pedido-medico/${fileName}`, {
      responseType: "blob",
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter requerimento médico.");
      });
  }

  obterZipDocumentosValorAdicional(nomeArquivo: string): Promise<any> {
    return this.get(`/atendimento/comprovante/${nomeArquivo}`, {
        responseType: "blob",
      })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter comprovante de intercorrência.");
      });
  }

  recusarSolicitacaoOrcamento(idAtendimento: number, justificativaRecusa: JustificativaRecusaDTO): Promise<RetornoMensagemDTO> {
    return this.put(`/atendimento/central/${idAtendimento}/recusar-solicitacao`, justificativaRecusa)
      .then((response: AxiosResponse) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao efetuar a recusa da solicitacao.");
    })
    }

  aprovarSolicitacaoOrcamento(idAtendimento: number, observacao: ObservacaoAprovacaoDTO): Promise<RetornoMensagemDTO> {
    return this.put(`/atendimento/central/${idAtendimento}/aprovar-solicitacao`, observacao)
      .then((response: AxiosResponse) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao efetuar a recusa da solicitacao.");
      })
  }

  incluirOrcamento(idAtendimento: number, orcamento: OrcamentoDTO): Promise<RetornoMensagemDTO> {
    return this.post<OrcamentoDTO>(`/atendimento/central/${idAtendimento}/incluir-orcamento`, orcamento)
      .then((response: AxiosResponse) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao finalizar orçamento.");
      })
  }

  recusarValorAdicional(idAtendimento: number, justificativa: JustificativaValorAdicionalDTO): Promise<RetornoMensagemDTO> {
    return this.put<JustificativaValorAdicionalDTO>(`/atendimento/central/${idAtendimento}/recusar-valor-adicional`, justificativa)
    .then((response: AxiosResponse) => {
      const { data } = response;
      return data;
    })
    .catch((err: AxiosError) => {
      console.error(err.response ? err.response : err);
      throw new Error("Falha ao recusar valor adicional");
    });
  }

  aprovarValorAdicional(idAtendimento: number, justificativa: JustificativaValorAdicionalDTO): Promise<RetornoMensagemDTO> {
    return this.put<JustificativaValorAdicionalDTO>(`/atendimento/central/${idAtendimento}/aprovar-valor-adicional`, justificativa)
    .then((response: AxiosResponse) => {
      const { data } = response;
      return data;
    })
    .catch((err: AxiosError) => {
      console.error(err.response ? err.response : err);
      throw new Error("Falha ao aprovar valor adicional");
    });
  }

  pesquisarEspecialidadesRemocao(filtro: EspecialidadeFiltroDTO): Promise<EspecialidadeDTO[]> {
    return this.get<EspecialidadeDTO>("/especialidades/listar-todas", {params: filtro})
            .then((res: AxiosResponse) => {
              const {data} = res;
              return data;
            })
            .catch((err: AxiosError) => {
              console.error(err);
              throw Error("Falha ao obter especialidades");
            });
  }

  pesquisarComprovantesTransferencia(filtro: FiltroComprovanteTransferenciaDTO): Promise<ServerSidePaging<AtendimentoNotaFiscalDTO>> {
    return this.get('/atendimento/prestadores/comprovante-transferencia', { params: filtro })
      .then((res: any) => {
        const {data} = res;
        return data;
      })
      .catch((err: AxiosError) => {
        console.error(err);
        throw Error('Falha ao obter comprovantes.');
      })
  }

  downloadComprovante(nomeArquivo: string): Promise<any> {
    return this.get(`/atendimento/comprovante/${nomeArquivo}`, {
      responseType: "arraybuffer",
    });
  }

  confirmarComprovante(payload: ConfirmarComprovanteTransferenciaDTO): Promise<any> {
    return this.post(`/atendimento/contabilidade/comprovantes`, payload);
  }

  obterNomeComprovante(idAtendimento: number): Promise<string> {
    return this.get(`/atendimento/${idAtendimento}/comprovante-transferencia`)
      .then((res: AxiosResponse) => {
        const {data} = res;
        return data;
      })
      .catch((err: AxiosError) => {
        console.error(err);
        throw Error('Falha ao obter comprovantes.');
      });
  }

  obterPagamentos(idAtendimento: number): Promise<TransacoesDTO> {
    return this.get(`/atendimento/pagamentos/${idAtendimento}`)
      .then((res: AxiosResponse) => {
        const {data} = res;
        return data;
      })
      .catch((err: AxiosError) => {
        console.error(err);
        throw Error('Falha ao obter pagamentos.');
      });
  }
}

export const servicosSaudeAtendimentoApi = new ServicosSaudeAtendimentoApi(servicosSaudeApiConfig);
